import type { MemberDataFirestoreRecord } from "@albertine/types";
import React from "react";
import { NavLink } from "react-router-dom";
import type { Request } from "../../common/types/Request";
import "./MobileMemberViewFooter.css";

type Props = {
    member: MemberDataFirestoreRecord;
    request: Request | undefined;
    memberRequests: Request[];
};

const MobileViewFooter = function MobileViewFooter(props: Props) {
    const { member, memberRequests, request } = props;

    return (
        <div className="mobile-view-footer">
            {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
            <NavLink
                to={request ? `/request/${request.id}` : `/member/${member.id}`}
                className="mobile-view-footer__link"
                activeClassName="active"
                exact
            >
                Chat
            </NavLink>
            {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
            <NavLink
                to={`/member/${member.id}/requests`}
                className="mobile-view-footer__link"
                activeClassName="active"
                exact
            >
                {`Requests (${memberRequests.length})`}
            </NavLink>
            {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
            <NavLink
                to={`/member/${member.id}/details`}
                className="mobile-view-footer__link"
                activeClassName="active"
                exact
            >
                Member
            </NavLink>
        </div>
    );
};

export default MobileViewFooter;
